var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"banner-title",class:{'banner-title--heavy': !_vm.overline}},[(_vm.overline)?_c('span',{staticClass:"banner-title__overline"},[_vm._v(" "+_vm._s(_vm.overline)+": ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }